{
  "currentActivity": "Actividad actual",
  "online": "en línea",
  "active": "activos",
  "deviceMarkerUpdating": "Actualizando...",
  "doNotShowThisAgain": "No mostrar esto nuevamente",
  "inFieldWithFieldName": "En el campo ${{fieldName}}",
  "locateDevice": {
    "helpBody": "Para ser localizado, un dispositivo debe estar encendido y tener recepción celular.",
    "coordinatesWithLongitudeAndLatitude": "Coordenadas: {{longitude}}, {{latitude}}",
    "copyLocation": "Copiar",
    "goTo": "Ir a",
    "linkTo": "Localizar",
    "noLocationMessage": "Este dispositivo no tiene ubicación GPS. Asegúrese de que esté encendido y tenga recepción celular.",
    "noLocationTitle": "Sin ubicación GPS",
    "openInApple": "Abrir en Apple Maps",
    "openInGoogleMaps": "Abrir en Google Maps",
    "title": "Ubicación del dispositivo"
  },
  "locateDeviceCooordinatesLabel": "Coordenadas",
  "locateField": {
    "appleMaps": "Ir a (Apple Maps)",
    "errorMessage": {
      "message": "No se puede calcular el centro del campo. Póngase en contacto con el servicio de asistencia.",
      "title": "Algo salió mal"
    },
    "googleMaps": "Ir a (Google Maps)"
  },
  "mapSettingsFieldColor": "Color del campo",
  "mapSettingsMapTypeId": "Estilo de mapa",
  "mapSettingsTitle": "Configuración del mapa",
  "quickActions": {
    "connectDevices": "Conectar dispositivos",
    "createField": "Nuevo campo",
    "manageSchedules": "Administrar horarios",
    "mapSettings": "Configuración del mapa",
    "newDevice": "Nuevo dispositivo",
    "title": "Comportamiento",
    "viewDeviceActivity": "Ver la actividad del dispositivo",
    "viewSchedules": "Ver horarios"
  },
  "selectedDevice": {
    "commandsLink": "Controles",
    "deviceProfileLink": "Administrar",
    "notifications": "Notificaciones"
  },
  "selectedReelRunTitle": "Carrera de carrete",
  "setReelDistance": {
    "distanceMmCurrent": {
      "errors": {
        "max": "Este valor es demasiado alto que el umbral permitido para anulaciones de distancia manuales"
      },
      "labelWithUnitLabel": "Distancia restante ({{unitLabel}})"
    },
    "distanceMmMax": {
      "labelWithUnitLabel": "Distancia extendida ({{unitLabel}})"
    },
    "errorMessage": "Nuestro servicio no puede procesar su solicitud en este momento. Inténtelo nuevamente.",
    "instructions": "¿Anular las distancias de carrera?",
    "linkTo": "Definir distancia",
    "noActiveRunsMessage": "No se encontró ninguna ejecución de carrete activa para este dispositivo.",
    "noActiveRunsTitle": "No hay carrera de carrete activa",
    "notRetractingMessage": "No se puede ajustar la distancia de un carrete que no se está retrayendo.",
    "successMessage": "Los cambios se han guardado. Espere una actualización...",
    "title": "Establecer la distancia del carrete",
    "warning": "Esto no se puede deshacer"
  },
  "setRunDirection": {
    "flipButton": "Voltear",
    "instructions": "¿Anular la dirección de la ejecución?",
    "linkTo": "Definir dirección",
    "title": "Establecer la dirección de funcionamiento del carrete"
  },
  "setApplicationType": {
    "instructions": "¿Qué aplicó esta pasada? Esto anula el tipo de aplicación de la configuración del carrete solo para esta pasada.",
    "linkTo": "Definir tipo de aplicación",
    "title": "Definir tipo de aplicación de la pasada"
  },
  "setRunField": {
    "automaticOption": "Automático (GPS)",
    "instructions": "Asigne esta pasada a un campo. Automático usa el punto final GPS de la pasada; elegir un campo fija la pasada a ese campo y usa la dirección de hileras de ese campo.",
    "linkTo": "Definir campo",
    "title": "Definir campo de la pasada"
  },
  "manageReelRun": "Gestionar pasada del carrete",
  "deviceActivityHide": "Ocultar actividad",
  "deviceActivityLabel": "Actividad",
  "deviceActivityShow": "Mostrar actividad",
  "heatmapLayersHide": "Ocultar mapa de calor",
  "heatmapLayersLabel": "Mapa de calor",
  "heatmapLayersShow": "Mostrar mapa de calor",
  "heatmapLegendTitle": "Application Depth - Last 7 Days",
  "showDevices": "Dispositivos",
  "showFields": "Campos",
  "showReelRuns": "El carrete se ejecuta",
  "showTimeline": "Cronología",
  "title": "Mapa de estado",
  "unknownDevice": "Dispositivo desconocido",
  "unknownFields": {
    "description": "Los recorridos de carretes no serán visibles a menos que caigan dentro de los límites de uno de sus campos.",
    "dismissButton": "ahora no",
    "drawFieldButton": "Botón de dibujar campo",
    "title": "Campos desconocidos",
    "warningText": "FarmHQ recibió ejecuciones de carrete para los siguientes dispositivos en campos desconocidos:"
  }
}
